import {
	createStore
} from 'vuex'
import {
	getUserDetail
} from '@/api/auth'

const store = createStore({
	state: {
		user: {
			username: '',
			id: null,
			isBoss: 0,
			role: '',
			department: ''
		}
	},
	mutations: {
		SET_USER(state, user) {
			state.user = user
		},
		setUserInfo(state, user) {
			state.user = user
		},
		clearUserInfo(state) {
			state.user = {
				username: '',
				id: null,
				isBoss: 0,
				role: '',
				department: '',
				avatar: ''
			}
		}
	},
	actions: {
		async fetchUserInfo({
			commit
		}) {
			try {
				const res = await getUserDetail()
				// console.log(res.data);
				commit('SET_USER', res.data)
				localStorage.setItem('user', JSON.stringify(res.data))
			} catch (error) {
				console.error('获取用户信息失败:', error)
			}
		}
	},
	getters: {
		isUserId: state => state.user.id,
		isAdmin: state => state.user.isBoss,
		userInitials: state => {
			if (!state.user.username) return ''
			return state.user.username.charAt(0).toUpperCase()
		}
	}
})

export default store